import { Accordion, Box, Text, TextButton } from '@wix/design-system';
import React, { useState } from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { useWhoisMobileOptimizations } from '../../../../hooks/useWhoisMobileOptimizations';
import s from '../whoisResultsPage.scss';
const RDDS_COMPLAINT_URL = 'https://www.icann.org/compliance/complaint';
export const TosSection = _ref => {
  let {
    tos,
    whoisBiParams
  } = _ref;
  const {
    t,
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const mobileOptimizations = useWhoisMobileOptimizations();
  const [isOpen, setIsOpen] = useState(!mobileOptimizations);
  if (!tos.text && !tos.url) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden",
    className: s.tosAccordion
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title: t('domain_search_gate.whois_results.accordion.terms_of_service.title'),
      toggleIconPlacement: 'start',
      open: isOpen,
      onToggle: () => {
        const next = !isOpen;
        setIsOpen(next);
        if (!whoisBiParams) {
          return;
        }
        DomainSearchGateModule.internals.bi.onWhoisGeneralAction == null || DomainSearchGateModule.internals.bi.onWhoisGeneralAction({
          ...whoisBiParams,
          action: next ? 'expand' : 'collapse',
          button_name: 'terms of service'
        });
      },
      children: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "SP4",
        padding: "SP4 0"
      }, tos.text && /*#__PURE__*/React.createElement(Text, {
        size: "small",
        secondary: true
      }, tos.text), /*#__PURE__*/React.createElement(Text, {
        size: "small",
        secondary: true
      }, /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "domain_search_gate.whois_results.accordion.terms_of_service.inaccuracy_complaint",
        components: [/*#__PURE__*/React.createElement(TextButton, {
          as: "a",
          size: "small",
          underline: "always",
          className: s.accordionInlineLink,
          href: RDDS_COMPLAINT_URL,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            color: 'inherit'
          },
          onClick: () => {
            if (!whoisBiParams) {
              return;
            }
            DomainSearchGateModule.internals.bi.onWhoisGeneralAction == null || DomainSearchGateModule.internals.bi.onWhoisGeneralAction({
              ...whoisBiParams,
              action: 'redirect',
              value: RDDS_COMPLAINT_URL,
              button_name: 'file complaint with ICANN'
            });
          }
        })]
      })))
    }]
  }));
};
//# sourceMappingURL=TosSection.js.map